import(/* webpackMode: "eager" */ "/src/app/page.tsx");
